"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const text_vue_1 = __importDefault(require("./text.vue"));
let CommentIndex = class CommentIndex extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.commentList = [];
    }
    handleTabClick(params) {
        0; //全部  1//好评
        if (params.index == 0) {
            this.commentList = this.list;
        }
        else if (params.index != 4) {
            this.commentList = this.list.filter((v) => v.type == params.index);
        }
        else {
            this.commentList = this.list.filter((v) => v.havePhoto);
        }
        // const req = {
        //   id: this.$route.params.id,
        //   type: params.index,
        //   status: true,
        //   pageNo: '1',
        //   pageSize: '1000'
        // }
        // commentsList(req).then(res => {
        //   this.commentList = res
        // })
    }
    mounted() {
    }
};
__decorate([
    vue_property_decorator_1.Prop(Array)
], CommentIndex.prototype, "list", void 0);
CommentIndex = __decorate([
    vue_property_decorator_1.Component({
        components: { Comment: text_vue_1.default }
    })
], CommentIndex);
exports.default = CommentIndex;
